// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ripple from 'vuetify/lib/directives/ripple'
import HomeIcon from '../layouts/default/Icons/HomeIcon'
import UserIcon from '../layouts/default/Icons/UserIcon'
import FAIcon from '../layouts/default/Icons/FAIcon'
import UniverseIcon from '../layouts/default/Icons/UniverseIcon'
import NodeIcon from '../layouts/default/Icons/NodeIcon'
import AppIcon from '../layouts/default/Icons/AppIcon'
import AppsIcon from '../layouts/default/Icons/AppsIcon'
import HelpIcon from '../layouts/default/Icons/HelpIcon'
import SettingsIcon from '../layouts/default/Icons/SettingsIcon'
import JupyterIcon from '../layouts/default/Icons/JupyterIcon'
import AlienIcon from '../layouts/default/Icons/AlienIcon'
import AppFailedIcon from '../layouts/default/Icons/AppFailedIcon'
import ArchitectIcon from '../layouts/default/Icons/ArchitectIcon'
import VisitorIcon from '../layouts/default/Icons/VisitorIcon'

Vue.use(Vuetify, { directives: { ripple } })

const theme = {
  primary: '#2196F3',
  secondary: '#9C27b0',
  accent: '#FF9800',
  info: '#00CAE3',
  success: '#4CAF50',
  warning: '#FB8C00',
  error: '#FF5252',
}

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  icons: {
    values: {
      expand: 'mdi-menu-down',
      home: {
        component: HomeIcon,
      },
      user: {
        component: UserIcon,
      },
      fa: {
        component: FAIcon,
      },
      universe: {
        component: UniverseIcon,
      },
      node: {
        component: NodeIcon,
      },
      app: {
        component: AppIcon,
      },
      apps: {
        component: AppsIcon,
      },
      help: {
        component: HelpIcon,
      },
      settings: {
        component: SettingsIcon,
      },
      jupyter: {
        component: JupyterIcon,
      },
      alien: {
        component: AlienIcon,
      },
      appFailed: {
        component: AppFailedIcon,
      },
      architect: {
        component: ArchitectIcon,
      },
      visitor: {
        component: VisitorIcon,
      },
    },
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
})
